import EfScrollAni from '@/efscrollani';

export const getTreaserAni = () => {
    if (typeof window !== 'undefined') {
        return window.AniContainer || new EfScrollAni();
    }
};
